export const placeholderCss = {
  color: "rgba(64, 64, 64, 0.53)",
  display: "inline-block",
  fontSize: "13px",
  fontStyle: "normal",
  fontWeight: "normal",
  lineHeight: "28px",
  verticalAlign: "middle"
}
